export default {
    //TODO: APP
    addNote ({ commit, state, getters }, payload) {
        if(typeof payload.scrollTo === 'undefined' || payload.scrollTo) {
            window.scrollTo(0, 0)
        }

        if(typeof payload === 'string') {
            commit('ADD_NOTIFICATION', {items: [{message: payload, type: 'info'}], target: null})
        } else {
            commit('ADD_NOTIFICATION', {items: typeof payload.item === 'undefined' ? payload.items : [payload.item], target: payload.target || null})
        }
    },
    emptyNotes ({ commit}) {
        commit('EMPTY_NOTIFICATIONS')
    },
    //TODO: CART
    saveCart ({ commit, state, dispatch, getters }, payload) {
        if(getters.cartItems.length) {
            axios.put(`/cart/save${getters.cartHash ? '/' + getters.cartHash : ''}`, {...getters.saveCartRequest, ...{page: payload ? payload.page : null}, ...{cartAppendurl: getters.cartAppendurl}, ...{cartSharedHash: getters.sharedCartHash}}).then((response) => {
                commit('STORE_CART_HASH', response.data.hash)
                dispatch('checkCartItems')
                commit('SET_DATALAYER_CART')
                if(payload.page == "cart"){
                    $(".checkout-button").attr('disabled', false);
                }
                state.data_layer_view_cart.ecommerce.value = getters.itemsTotalPrice ? getters.itemsTotalPrice.toFixed(2) : "0";
                if(getters.cartAppendurl == 'cart'){
                    window.history.pushState(null, null, "".concat(location.pathname).concat('?retrieved'));
                }
                if(response.data.doEmptyCart == 'yes'){
                    commit('EMPTY_CART')
                    commit('CLEAR_SHIPPING_RATES')
                    dispatch('clearSharedCartHash')
                    dispatch('removeCart')
                }
                else{
                    if(payload.page == "cart"){
                        const quantityNoteIndex =
                            state.app.notifications.items.findIndex(
                                note => (note.name === 'quantity')
                            );
                        if (quantityNoteIndex !== -1) {
                            state.app.notifications.items.splice(quantityNoteIndex, 1);
                        }
                    }
                }
            }).catch(e => {
                // console.error('Error: ', e)
                if(e.response.status == 422){
                    const errs = []
                    if(e.response.data.errors.remove != undefined){
                        errs.push({name: 'remove', message: e.response.data.errors.remove[0], type: 'validation'})
                    }
                    else{
                        for (const item in e.response.data.errors) {
                            errs.push({name: item, message: e.response.data.errors[item][0], type: 'validation'})
                        }
                    }
                    if(getters.cartHash == null && payload.page == "product"){
                        commit('EMPTY_CART')
                        commit('CLEAR_SHIPPING_RATES')
                        dispatch('clearSharedCartHash')
                    }
                    else if(e.response.data.errors.remove != undefined && e.response.data.errors.disabledProducts != undefined){
                        e.response.data.errors.disabledProducts.forEach(item => {
                            let removeProduct = state.cart.items.find(items => items.variant_id == item);

                            if(!removeProduct)
                            {
                                removeProduct = state.cart.items.find(items => items.id == item);
                            }

                            if(removeProduct)
                            {
                                dispatch('removeDisabledItemFromCart',removeProduct);
                            }
                        })
                    }
                    // dispatch('emptyNotes')
                    dispatch('addNote', {items: errs})
                    $("#place_order").addClass('disabled');
                    $("#place_order").attr('disabled', true);
                    $("#accordionPayment").css('pointerEvents', 'none');
                    setTimeout(() => {
                        if(payload.page == "checkout"){
                            window.location.href = '/cart/';
                        }
                    }, 1000);
                    if(payload.page == "cart"){
                        $(".checkout-button").attr('disabled', true);
                    }
                }
            });
        }
        else if(getters.cartHash && !getters.cartItems.length)
        {
            axios.put(`/cart/save${getters.cartHash ? '/' + getters.cartHash : ''}`, {...getters.saveCartRequest, ...{page: payload ? payload.page : null}, ...{cartAppendurl: getters.cartAppendurl}, ...{cartSharedHash: getters.sharedCartHash}}).then((response) => {
                commit('STORE_CART_HASH', null)
                if(response.data.doEmptyCart == 'yes'){
                    commit('EMPTY_CART')
                    commit('CLEAR_SHIPPING_RATES')
                    dispatch('clearSharedCartHash')
                    dispatch('removeCart')
                }
            }).catch(e => {
                // console.error('Error: ', e)
                if(e.response.status == 422){
                    const errs = []
                    for (const item in e.response.data.errors) {
                        errs.push({name: item, message: e.response.data.errors[item][0], type: 'validation'})
                    }
                    commit('EMPTY_CART')
                    commit('CLEAR_SHIPPING_RATES')
                    dispatch('clearSharedCartHash')
                    dispatch('removeCart')
                    $("#place_order").addClass('disabled');
                    $("#place_order").attr('disabled', true);
                    $("#accordionPayment").css('pointerEvents', 'none');
                    setTimeout(() => {
                        if(payload.page == "checkout"){
                            window.location.href = '/cart/';
                        }
                    }, 1000);
                    if(payload.page == "cart"){
                        $(".checkout-button").attr('disabled', true);
                    }
                }
            });
        }
    },
    freshProducts ({ commit, state, getters }, payload) {
        if(getters.cartItems.length) {
            commit('LOADING', true)
            axios.post(`/cart/get-products`, {idList: getters.cartItems.map(i => i.id)}).then(({data}) => {
                commit('SET_CART_PRODUCT_DATA', data.products)
                commit('LOADING', false)
            }).catch(e => {
                console.error('Error: ', e)
                commit('LOADING', false)
            });
        }
    },
    removeCart ({ commit, getters }) {
        if(getters.cartHash) {
            axios.get(`/cart/remove/${getters.cartHash}`).then((response) => {
                commit('STORE_CART_HASH', response.data.hash)
                dispatch('linkedProducts',4)
            }).catch(e => {
                console.error('Error: ', e)
            });
        }
    },
    addToCart ({ commit, dispatch }, cartItem) {
        if(cartItem) {
            commit('ADD_TO_CART', cartItem)
            commit('CLEAR_SHIPPING_RATES')
            // const message = `<i class="fa fa-check-circle" style="color: #8fae1b" aria-hidden="true"></i> ${cartItem.quantity} x ${cartItem.title} product added to cart. <span class="view-cart-btn"><a href="/cart/">View Cart</a></span>`;
            // dispatch('addNote', {item: {message: message, type: 'success'}})
        }
    },
    updateCartQuantity ({ commit, dispatch }, payload) {
        commit('UPDATE_CART_QUANTITY', payload)
    },
    updateCustomPrice({ commit, dispatch }, peyload) {

        commit('UPDATE_CUSTOM_PRICE', peyload)
    },
    emptyCart ({ commit, dispatch }) {
        commit('EMPTY_CART')
        commit('CLEAR_SHIPPING_RATES')
        dispatch('addNote', {items: [{type: 'all_removed'}], target: 'all_removed', scrollTo: false})
        dispatch('linkedProducts',4)
    },
    clearSharedCartHash ({ commit }){
        commit('CLEAR_SHARED_CART_HASH')
    },
    updateCartItem ({ commit, dispatch }, payload) {
        commit('UPDATE_CART_ITEM', payload)
    },
    removeFromCart ({ commit, state, dispatch, getters }, item) {
        commit('REMOVE_FROM_CART', item)
        const notes = [{item: item, type: 'remove_from_cart'}]
        state.app.notifications.items = []
        dispatch('addNote', {items: notes, target: 'remove_from_cart', scrollTo: false})
        dispatch('beforeCalcGroundFreight',1)

        // commit('CLEAR_SHIPPING_RATES')
    },
    removeDisabledItemFromCart ({ commit, state, dispatch }, item) {
        commit('REMOVE_FROM_CART', item)
        const notes = [{item: item, type: 'remove_from_cart'}]
        dispatch('calculateShipping',1)
        dispatch('linkedProducts',1)
        // commit('CLEAR_SHIPPING_RATES')
    },
    linkedProducts ({ commit, dispatch, getters }, limit) {
        let linkedProductIds = []
        for (let i=0; i<getters.cartItems.length; i++) {
            // if (getters.cartItems[i].includes())
            linkedProductIds = [...linkedProductIds, ...(getters.cartItems[i].cross_sell_products || [])]
        }

        const cartItemIds = getters.cartItems.map(i => i.id)
        linkedProductIds = linkedProductIds.filter(x => !cartItemIds.includes(x));

        axios.post(`/cart/get-cart-products`, {idList: cartItemIds, limit: limit}).then(({data}) => {
            commit('SET_CART_LINKED_PRODUCT_DATA', data.products)
            commit('SET_DATALAYER_IMPRESSIONS')

            dispatch('beforeCalcGroundFreight',1)
        }).catch(e => {
            console.error('Error: ', e)
            commit('LOADING', false)
        });

    },
    productLinkedProducts ({ commit, dispatch, getters }, item) {
        if(item.upsell_products && item.upsell_products.length) {
            axios.post(`/cart/get-products`, {idList: item.upsell_products}).then(({data}) => {
                commit('SET_PRODUCT_LINKED_PRODUCT_DATA', data.products)
            }).catch(e => {
                console.error('Error: ', e)
                commit('LOADING', false)
            });
        }
    },
    undoToCart ({ commit, dispatch, getters}, item) {
        commit('UNDO_TO_CART', item)
        dispatch('beforeCalcGroundFreight',1)
        dispatch('cartMinQtyNote')
        dispatch('linkedProducts',4)
        dispatch('saveCart', {page: 'cart'});
    },
    undoRemovedItems({ commit, dispatch , getters }) {
        commit('UNDO_REMOVED_ITEMS')
        dispatch('beforeCalcGroundFreight',1)
        dispatch('cartMinQtyNote')
        dispatch('linkedProducts',4)
        dispatch('saveCart', {page: 'cart'});
    },
    //TODO: SHIPPING
    calculateShipping ({ commit, state, getters, dispatch }, payload = 0) {
        commit('LOADING', true)

        //dispatch('calcGroundFreight');
        return axios.post('/shipping/calculate-shipping', getters.shippingCalculateRequest).then(({data}) => {
            commit('UPDATE_SHIPPING_RATES', data);
            commit('LOADING', false);
            getters.billingInfo.billing_zipcode = getters.shippingCalculateRequest.zipcode;
            getters.shippingInfo.shipping_zipcode = getters.shippingCalculateRequest.zipcode;
                if (!data.length) {
                    dispatch('calcGroundFreight');
                }
                return [null, data]
        }).catch(errors => {
            commit('LOADING', false);
            commit('UPDATE_SHIPPING_RATES', null);
            if (errors.response && errors.response.status === 422 && errors.response.data) {
                const errs = []
                if(payload == 0)
                {
                    for (const item in errors.response.data.errors) {
                        errs.push({name: item, message: errors.response.data.errors[item][0], type: 'validation'})
                    }
                }
                dispatch('addNote', {items: errs})
            } else {
                dispatch('calcGroundFreight');
            }
            getters.billingInfo.billing_zipcode = "";
            getters.shippingInfo.shipping_zipcode = "";
            return [errors, null]
        });
    },
    beforeCalcGroundFreight({ commit,state ,dispatch}){
        commit('LOADING', true)

        const excludedProducts = [];
        for (let i = 0; i < state.cart.items.length; i++) {
            if(state.cart.items[i].grouped_product) {
                excludedProducts.push(Number(state.cart.items[i].grouped_product.id));
            }
        }

        axios.post('/cart/calc-ground-freight', state.cart.items.filter(i => !excludedProducts.includes(Number(i.id)))).then(({data}) => {
            commit('LOADING', false);
            const currentRateIndex = state.before_shipping_methods.rates.findIndex(i => i.type === state.before_shipping_methods.selected);
            state.before_shipping_methods.defaultCost = data[0].cost;
            if(currentRateIndex !== -1)
            {
                state.before_shipping_methods.rates[currentRateIndex].cost = data[0].cost;
                state.before_shipping_methods.defaultCost = data[0].cost;
                state.shipping_methods.custom_price = state.shipping_methods.custom_price;

            }

            let isLtl = false;

            const rates = (data || []).sort((a,b)=>a.cost - b.cost).filter(i => !isLtl || i?.label?.includes('LTL'));
            state.before_shipping_methods.rates = isLtl && rates[0] ? [{...rates[0], ...{label: 'Shipping - LTL:'}}] : rates;
            state.before_shipping_methods.selected = data && data[0] ? (data[0].id || (data[0].type === 'ground_freight' ? 'ground_freight' : null)): null

            const method = state.before_shipping_methods.rates.find(i => i.id === state.before_shipping_methods.selected)
            let freeOrNot = method && typeof method.cost !== 'undefined' ? (state.shipping_methods.custom_price ?? Number(method.cost)) : (state.shipping_methods.custom_price ??  0);
            state.before_shipping_methods.shipFree = freeOrNot

            if(!freeOrNot || state.billing_info.billing_zipcode)
            {
                dispatch('calcGroundFreight');
            }
            else
            {
                commit('CLEAR_SHIPPING_RATES');
            }

            commit('LOADING', false);
            return [null, data]
        })
    },
    calcGroundFreight({ commit,state }){
        commit('LOADING', true)

        const excludedProducts = [];
        for (let i = 0; i < state.cart.items.length; i++) {
            if(state.cart.items[i].grouped_product) {
                excludedProducts.push(Number(state.cart.items[i].grouped_product.id));
            }
        }

        axios.post('/cart/calc-ground-freight', state.cart.items.filter(i => !excludedProducts.includes(Number(i.id)))).then(({data}) => {

            const currentRateIndex = state.shipping_methods.rates.findIndex(i => i.type === state.shipping_methods.selected);
            state.shipping_methods.defaultCost = data[0].cost;
            if(currentRateIndex !== -1)
            {
                state.shipping_methods.rates[currentRateIndex].cost = data[0].cost;
                state.shipping_methods.defaultCost = data[0].cost;
                state.shipping_methods.custom_price = state.shipping_methods.custom_price;

                var isClassExists = document.getElementsByClassName('custom_shipping_qty_update');
                if (isClassExists.length > 0) {
                    setTimeout( () => {
                        isClassExists[0].value = state.shipping_methods.custom_price;
                    }, 50)
                }
            }
            commit('UPDATE_SHIPPING_RATES', data);
            commit('LOADING', false);
            return [null, data]
        })
    },
    //TODO: SHARE CART
    saveAndShare ({ commit, state, getters, dispatch }, cartId) {
        dispatch('emptyNotes')
        commit('LOADING', true)
        return axios.post('/cart/save-and-share', {...getters.saveAndShareRequest, ...{cartId}}).then(({data}) => {
            state.shipping_methods.custom_price = null;
            dispatch('beforeCalcGroundFreight');
            commit('LOADING', false);
            return [null, data]
        }).catch(errors => {
            commit('LOADING', false);

            if (errors.response && errors.response.status === 422 && errors.response.data) {
                const errs = []
                for (const item in errors.response.data.errors) {
                    errs.push({name: item, message: errors.response.data.errors[item][0], type: 'validation'})
                }
                dispatch('addNote', {items: errs, target: 'dont_show', scrollTo: false})
            }

            if (errors.response && errors.response.status === 500 && errors.response.data) {
                for(let i = 0; i < errors.response.data.messages.length; i++) {
                    dispatch('addNote', {item: {message: errors.response.data.messages[i], type: 'error'}, target: 'share_cart', scrollTo: false})
                }
            }

            return [errors, null]
        });
    },
    loading({ commit, getters, dispatch }, payload){
        return commit('LOADING', payload);
    },
    saveAndGenerateLink ({ commit, getters, dispatch }) {
        dispatch('emptyNotes')
        commit('LOADING', true)
        return axios.post('/cart/save-and-generate-link', getters.saveAndGenerateLinkRequest).then(({data}) => {
            commit('LOADING', false);
            return [null, data]
        }).catch(errors => {
            commit('LOADING', false);

            if (errors.response && errors.response.status === 422 && errors.response.data) {
                const errs = []
                for (const item in errors.response.data.errors) {
                    errs.push({name: item, message: errors.response.data.errors[item][0], type: 'validation'})
                }
                dispatch('addNote', {items: errs, target: 'dont_show', scrollTo: false})
            }

            if (errors.response && errors.response.status === 500 && errors.response.data) {
                for(let i = 0; i < errors.response.data.messages.length; i++) {
                    dispatch('addNote', {item: {message: errors.response.data.messages[i], type: 'error'}, target: 'share_cart', scrollTo: false})
                }
            }

            return [errors, null]
        });
    },
    getCoupon ({ commit, getters, dispatch }, code) {
        dispatch('emptyNotes')
        commit('LOADING', true)
        return axios.post('/cart/get-coupon', {'code' : code}).then(({data}) => {
            commit('LOADING', false);
            commit('SAVE_COUPON', data);
            dispatch('addNote', 'Coupon code applied successfully.')
            return [null, data]
        }).catch(errors => {
            commit('LOADING', false);
            commit('SAVE_COUPON', null);

            if (errors.response && errors.response.status === 422 && errors.response.data) {
                const errs = []
                for (const item in errors.response.data.errors) {
                    errs.push({name: item, message: errors.response.data.errors[item][0], type: 'validation'})
                }
                dispatch('addNote', {items: errs})
            }

            if (errors.response && errors.response.status === 500 && errors.response.data) {
                for(let i = 0; i < errors.response.data.messages.length; i++) {
                    dispatch('addNote', {item: {message: errors.response.data.messages[i], type: 'error'}})
                }
            }

            return [errors, null]
        });
    },
    removeCoupon ({ commit }) {
        commit('SAVE_COUPON', null);
    },
    cartMinQtyNote ({ getters, state, dispatch }) {
        let items = {}
        getters.cartItems?.map((i) => {
            if (i.allow_combination) {
                if(!items[`parent_${i.id}`]) {
                    items[`parent_${i.id}`] = {
                        title: i.title,
                        min_quantity: i.min_quantity,
                        enable_functionality_for_admin: i.enable_functionality_for_admin,
                        quantity: 0,
                    };
                }

                items[`parent_${i.id}`].quantity = items[`parent_${i.id}`].quantity + (isNaN(i.quantity) ? 0 : Number(i.quantity));
            }
        });

        items = Object.values(items)
        let error = false;
        let enableFUnc = 0;
        if (items.length) {
            state.app.notifications.items = state.app.notifications.items.filter(item => item.type !== 'error');
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                enableFUnc = ( items[i].enable_functionality_for_admin && getters.auth ) || !getters.auth ? 1 : 0;

                if (enableFUnc && item.quantity < item.min_quantity && getters.cartType != 1) {
                    dispatch('addNote', {item: {
                            message: `The Minimum Order Quantity (MOQ) for ${item.title} is ${item.min_quantity}. In order to Proceed to Checkout please either, increase the quantity of the Item already in your Cart to at least ${item.min_quantity}, or add additional variations of the same Item (i.e. different size, texture, color etc.) so that the sum of the variations in your Cart is at least ${item.min_quantity}.`,
                            type: 'error',
                        }
                    })
                    error = true
                }
            }
        }

        if (error) {
            return {status: 'error'};
        } else {
            return {status: 'ok'};
        }
    },
    checkCartItems ({getters, state, dispatch})
    {
        return new Promise((resolve, reject) => {
            if(state.cart.items.length)
            {
                if(state.cart.hash)
                {
                    const params = {
                    'hash': state.cart.hash
                    };

                    axios.get('/cart/check-cart-items',{params}).then(({data}) => {

                        if(data.status)
                        {
                            if(data.messages && data.messages.length && (window.location.href.indexOf('cart') !== -1 || window.location.href.indexOf('checkout') !== -1))
                            {
                                let errs = [];
                                // state.app.notifications = {
                                //     target: null,
                                //     items: [],
                                // };
                                data.messages.forEach(item => {
                                    let removeItem = state.cart.items.find(items => items.variant_id == item.id);

                                    if(!removeItem)
                                    {
                                        removeItem = state.cart.items.find(items => items.id == item.id);
                                    }

                                    if(removeItem)
                                    {
                                        dispatch('removeDisabledItemFromCart',removeItem);
                                        errs.push({name: item.name, message: item.message, type: 'validation'})

                                    }
                                });
                                dispatch('addNote', {items: errs})

                                if(!state.cart.items.length)
                                {
                                    dispatch('removeCart');
                                    if(window.location.href.indexOf('cart') !== -1)
                                        window.history.pushState({href: window.location.origin+'/cart/'}, '', window.location.origin+'/cart/');
                                    else
                                         window.location.href = window.location.origin+'/cart/';

                                }

                                resolve();
                            }

                            resolve();
                        }


                    }).catch(errors => {
                    });

                }
            }
        })
    }
}
